export default class InputControlDisable{
    
    constructor(element) {
        this._input = element;
        this._target = document.querySelector('input[name="'+this._input.getAttribute('data-target')+'"]');
        this._targetLabel = document.querySelector('label[for="'+this._input.getAttribute('data-target')+'"]');
        
        this.bindEvents();
    }
    
    bindEvents(){
        this._input.addEventListener('change', () => {
            if(this._input.checked){
                this._target.disabled = false;
                this._targetLabel.classList.remove('disabled');
            }
            else{
                this._target.disabled = true;
                this._target.value = '';
                this._targetLabel.classList.add('disabled');
            }
        });
    }
    
}